import { hotFeature, trendingList } from "@/mocks/homeContent";
import { MetaItem, SectionHead } from "./Common";

export default function Trending() {
  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <div className="container-page">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <SectionHead
            eyebrow="Hot list · 今日热榜"
            title="今天谁在风口浪尖"
            desc="按全网讨论热度滚动整理，带你看清每一条话题为何被反复提起。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap self-start rounded-full bg-background-100 px-4 py-2 text-xs font-medium text-foreground-600 ring-1 ring-background-300/60">
            <i className="ri-time-line text-primary-500"></i>
            数据统计于 09-09 18:00
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          {/* feature card */}
          <article className="lg:col-span-3 flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/80">
            <div className="relative h-56 md:h-80 overflow-hidden">
              <img
                src={hotFeature.image}
                alt="时间线还原方法论深扒头条封面图"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                <i className="ri-flashlight-fill"></i>
                {hotFeature.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-2xl">{hotFeature.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{hotFeature.summary}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {hotFeature.keywords.map((k) => (
                  <span key={k} className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    # {k}
                  </span>
                ))}
              </div>
              <div className="mt-5 flex items-center gap-5 border-t border-background-300/60 pt-4 text-foreground-500">
                <MetaItem icon="ri-calendar-line">{hotFeature.date}</MetaItem>
                <MetaItem icon="ri-eye-line">{hotFeature.read} 阅读</MetaItem>
              </div>
            </div>
          </article>

          {/* ranking */}
          <div className="lg:col-span-2 flex flex-col rounded-lg bg-background-100 p-4 ring-1 ring-background-200/80 md:p-5">
            <div className="flex items-center justify-between px-1 pb-3">
              <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">热度排行 TOP 8</h3>
              <i className="ri-fire-line text-lg text-primary-500"></i>
            </div>
            <ol className="flex flex-1 flex-col divide-y divide-background-300/60">
              {trendingList.map((t, i) => (
                <li key={t.title}>
                  <div className="group flex items-center gap-3 rounded-md px-1 py-2.5 transition-colors hover:bg-background-200/60">
                    <span
                      className={
                        "flex h-7 w-7 flex-none items-center justify-center rounded-md font-heading text-sm font-bold " +
                        (i < 3 ? "bg-primary-500 text-background-50" : "bg-background-300/70 text-foreground-600")
                      }
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">{t.title}</p>
                      <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="whitespace-nowrap rounded-full bg-background-200/70 px-2 py-0.5 text-[11px] text-foreground-600">
                          {t.tag}
                        </span>
                        <span className="hidden truncate md:inline">{t.note}</span>
                      </p>
                    </div>
                    <span className={"flex-none whitespace-nowrap text-xs font-semibold " + (i < 3 ? "text-primary-600" : "text-foreground-400")}>
                      {t.heat}
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}